import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Award } from 'lucide-react';

const CourseGrid = ({ courses, title = "Mis Cursos" }) => {
    const navigate = useNavigate();
    const [filter, setFilter] = useState('all'); // 'all', 'in-progress', 'completed'

    const filteredCourses = courses.filter(course => {
        if (filter === 'completed') return course.isCompleted;
        if (filter === 'in-progress') return !course.isCompleted;
        return true;
    });

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                {title && <h3 className="text-xl font-bold text-slate-800">{title}</h3>}
                <div className="flex bg-slate-100 p-1 rounded-lg">
                    <button 
                        onClick={() => setFilter('all')}
                        className={`px-4 py-1.5 text-sm font-bold rounded-md transition-all ${
                            filter === 'all' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'
                        }`}
                    >
                        Todos
                    </button>
                    <button 
                        onClick={() => setFilter('in-progress')}
                        className={`px-4 py-1.5 text-sm font-bold rounded-md transition-all ${
                            filter === 'in-progress' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'
                        }`}
                    >
                        En Progreso
                    </button>
                    <button 
                        onClick={() => setFilter('completed')}
                        className={`px-4 py-1.5 text-sm font-bold rounded-md transition-all ${
                            filter === 'completed' ? 'bg-white text-green-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'
                        }`}
                    >
                        Completados
                    </button>
                </div>
            </div>

            {filteredCourses.length > 0 ? (
                <div className="grid md:grid-cols-2 gap-6">
                    {filteredCourses.map(course => (
                        <div 
                            key={course.id} 
                            className={`p-6 rounded-xl border shadow-sm hover:shadow-md transition-all ${
                                course.isCompleted 
                                ? 'bg-gradient-to-br from-white to-green-50/50 border-green-100' 
                                : 'bg-white border-slate-200'
                            }`}
                        >
                            <div className="flex items-start justify-between mb-4">
                                <div className={`w-12 h-12 rounded-lg ${course.image} flex items-center justify-center text-white shadow-lg`}>
                                    {course.isCompleted ? <Award size={24} /> : <BookOpen size={24} />}
                                </div>
                                <span className={`text-xs font-bold px-2 py-1 rounded border ${
                                    course.isCompleted 
                                    ? 'bg-green-100 text-green-700 border-green-200' 
                                    : 'bg-slate-100 text-slate-500 border-slate-200'
                                }`}>
                                    {course.isCompleted ? 'Completado' : 'En Progreso'}
                                </span>
                            </div>
                            <h4 className="text-lg font-bold text-slate-900 mb-2">{course.title}</h4>
                            <p className="text-sm text-slate-500 mb-4">
                                {course.isCompleted ? '¡Curso finalizado con éxito!' : `Próximo: ${course.lastModule}`}
                            </p>
                            
                            <div className="w-full bg-slate-100 h-2 rounded-full overflow-hidden mb-2">
                                <div 
                                    className={`h-full rounded-full transition-all duration-500 ${
                                        course.isCompleted ? 'bg-green-500' : 'bg-blue-600'
                                    }`}
                                    style={{ width: `${course.progress}%` }}
                                ></div>
                            </div>
                            <div className="flex justify-between text-xs text-slate-500 font-medium">
                                <span>{course.progress}% Completado</span>
                                <span>{course.totalModules} Módulos</span>
                            </div>
                            <button 
                                onClick={() => navigate(`/campus/course/${course.id}`)}
                                className={`w-full mt-4 py-2 font-bold text-sm rounded-lg transition-colors border flex items-center justify-center gap-2 ${
                                    course.isCompleted
                                    ? 'bg-green-600 text-white hover:bg-green-700 border-green-600 shadow-md shadow-green-600/20'
                                    : 'bg-slate-50 text-blue-600 hover:bg-blue-50 hover:text-blue-700 border-slate-200'
                                }`}
                            >
                                {course.isCompleted ? <><Award size={16}/> Ver Certificado</> : 'Continuar'}
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-12 bg-slate-50 rounded-xl border border-dashed border-slate-300">
                    <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-400">
                        <BookOpen size={32} />
                    </div>
                    <h3 className="text-lg font-bold text-slate-700 mb-1">No hay cursos en esta sección</h3>
                    <p className="text-slate-500 text-sm">
                        {filter === 'completed' 
                            ? 'Aún no has completado ningún curso. ¡Sigue aprendiendo!' 
                            : 'No tienes cursos en progreso actualmente.'}
                    </p>
                </div>
            )}
        </div>
    );
};

export default CourseGrid;
